<template>
  <div class="activity-info-view">
    <DailyGoal />
    <div class="activity-categories">
      <CategoryCounter
        v-for="(category, index) in categories"
        :key="index"
        :category="category.name"
        :value="category.value"
        :icon="category.icon"
      />
    </div>
    <client-only>
      <div v-if="isGuestUser" class="guest-banner">
        <LibraryGuestBanner />
      </div>
      <SuggestedBanner
        v-else-if="isSuggestedAssessmentBlockVisible"
        :close-button-visible="false"
      />
      <MyRedingLevel v-else />
    </client-only>
  </div>
</template>

<script>
import dayJS from '@/dayJS';
import ManagePublicationsStates from '@/enums/ManagePublicationsStatesEnum';
import DailyGoal from './DailyGoal.vue';
import CategoryCounter from './CategoryCounter.vue';
import SuggestedBanner from '@/components/views/LibraryBanner/SuggestedBanner/SuggestedBanner.vue';
import LibraryGuestBanner from '@/components/views/LibraryBanner/LibraryGuestBanner/LibraryGuestBanner.vue';
import MyRedingLevel from './MyRedingLevel.vue';

export default {
  name: 'ActivityInfo',
  components: {
    DailyGoal,
    CategoryCounter,
    SuggestedBanner,
    LibraryGuestBanner,
    MyRedingLevel
  },
  data() {
    return {};
  },
  computed: {
    isSuggestedAssessmentBlockVisible() {
      return (
        this.$store.getters['AssessmentStore/isAssessmentHistoryActualized'] &&
        this.$store.getters['ProgressStore/getIsAssessmentAvailable'] &&
        this.$store.getters['LibraryStore/isManagePublicationsStateInit'](
          ManagePublicationsStates.LIBRARY
        )
      );
    },
    isGuestUser() {
      return this.$store.getters['UserStore/isGuestUser'];
    },
    categories() {
      const achievements =
        this.$store.getters['ActivityStore/getUserAchievements'] || {};
      return [
        {
          name: this.$t('ActivityInfo.category.streak'),
          value: achievements.bestStreak || 0,
          icon: 'ico-fire-line'
        },
        {
          name: this.$t('ActivityInfo.category.completed'),
          value: achievements.completedBooks?.length || 0,
          icon: 'ico-book-line'
        },
        {
          name: this.$t('ActivityInfo.category.totalRead'),
          value: this.humanizeDuration(achievements.totalRead),
          icon: 'ico-sand-clock'
        },
        {
          name: this.$t('ActivityInfo.category.mostRead'),
          value: this.humanizeDuration(achievements.mostReading),
          icon: 'ico-timer-line'
        }
      ];
    }
  },
  methods: {
    humanizeDuration(minutes = 0) {
      const duration = dayJS.getDuration(minutes * 60 * 1000);
      return this.$t('MyActivity.read.time', {
        hours: duration.hours(),
        minutes: duration.minutes()
      });
    }
  }
};
</script>

<style lang="less">
@import '~@/assets/styles/base.less';

.activity-info-view {
  display: flex;
  gap: 16px;

  @media @narrow, @normal {
    flex-direction: column;
  }

  > * {
    flex: 1;

    @media @wide {
      max-width: calc((100% - 16px * 2) / 3);
    }
  }

  .guest-banner {
    .library-banner {
      padding: 8px;
    }
  }

  .activity-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .category-counter-view {
      flex: 1;
      min-height: 162px;
      @media @narrow, @wide {
        min-width: calc(50% - 8px);
      }
    }
  }

  .suggested-assessment-link {
    .suggested-assessment-wrapper {
      border: 1px solid #cbd5e1;

      @media @wide {
        align-items: flex-start;
        background: url('~@/assets/images/svg-images/pictures/pic-book.svg')
            no-repeat right -40px bottom -40px / 185px,
          url('~@/assets/images/svg-images/pictures/pic-boy.svg') no-repeat
            right 10px bottom -10px / 360px,
          url('~@/assets/images/svg-images/pictures/pic-books.svg') no-repeat
            right 220px bottom 0px / 200px;
      }
    }

    .suggested-assessment-side {
      margin-inline-start: 32px;
    }
  }
}
</style>
